<template>
    <div class="mt-auto flex-col flex items-center">
      <img :src="src" alt="" class="h-20" />
      <div class="bg-h-primary-500 w-[4.2rem]" :class="height"></div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  export default defineComponent({
    name: "RankItem",
    props: {
      src: {
        type: String,
        required: true,
      },
      height: {
        type: String,
        required: true,
      },
    },
  });
  </script>